import { render, staticRenderFns } from "./directions.vue?vue&type=template&id=24185175&scoped=true&"
import script from "./directions.vue?vue&type=script&lang=js&"
export * from "./directions.vue?vue&type=script&lang=js&"
import style0 from "./directions.vue?vue&type=style&index=0&id=24185175&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24185175",
  null
  
)

export default component.exports